export const studentConstants = {

    FETCH_STUDENTS_REQUEST: 'FETCH_STUDENTS_REQUEST',
    FETCH_STUDENTS_SUCCESS: 'FETCH_STUDENTS_SUCCESS',
    FETCH_STUDENTS_FAILURE: 'FETCH_STUDENTS_FAILURE',

    CREATE_STUDENTS_REQUEST: 'CREATE_STUDENTS_REQUEST',
    CREATE_STUDENTS_SUCCESS: 'CREATE_STUDENTS_SUCCESS',
    CREATE_STUDENTS_FAILURE: 'CREATE_STUDENTS_FAILURE',

    UPDATE_STUDENTS_REQUEST: 'UPDATE_STUDENTS_REQUEST',
    UPDATE_STUDENTS_SUCCESS: 'UPDATE_STUDENTS_SUCCESS',
    UPDATE_STUDENTS_FAILURE: 'UPDATE_STUDENTS_FAILURE',

    DELETE_STUDENT_REQUEST: 'DELETE_STUDENT_REQUEST',
    DELETE_STUDENT_SUCCESS: 'DELETE_STUDENT_SUCCESS',
    DELETE_STUDENT_FAILURE: 'DELETE_STUDENT_FAILURE',

    UPDATE_ACCESSCODE_REQUEST: 'UPDATE_ACCESSCODE_REQUEST',
    UPDATE_ACCESSCODE_SUCCESS: 'UPDATE_ACCESSCODE_SUCCESS',
    UPDATE_ACCESSCODE_FAILURE: 'UPDATE_ACCESSCODE_FAILURE',

}